module.exports = __webpack_public_path__ + "img/006刘凯松.fb20a416.jpg";